var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8332 50L85.6665 38.375L87.0832 23L72.0415 19.5833L64.1665 6.25L49.9998 12.3333L35.8332 6.25L27.9582 19.5417L12.9165 22.9167L14.3332 38.3333L4.1665 50L14.3332 61.625L12.9165 77.0417L27.9582 80.4583L35.8332 93.75L49.9998 87.625L64.1665 93.7083L72.0415 80.4167L87.0832 77L85.6665 61.625L95.8332 50ZM42.0415 69.6667L26.2082 53.7917L32.3748 47.625L42.0415 57.3333L66.4165 32.875L72.5832 39.0417L42.0415 69.6667Z",
    fill: "#69BEFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.5746c80fd1d9bc783f52da389a0c2ed2.svg";
export { ForwardRef as ReactComponent };